import { useParams, useLocation } from 'react-router-dom';
import { CreateProductForm } from '@/components/dashboard/products/CreateProductForm';
import { EditProductForm } from '@/components/dashboard/products/EditProductForm';
import { DashboardHead } from '@/components/SEO/DashboardHead';

export function ProductDetailsPage() {
  const { productId } = useParams();
  const location = useLocation();

  // Check if we're on the /products/new route
  if (location.pathname === '/dashboard/products/new') {
    return (
      <>
        <DashboardHead pageName="New Product" />
        <CreateProductForm />
      </>
    );
  }

  // Otherwise we're editing an existing product
  return (
    <>
      <DashboardHead pageName="Edit Product" />
      <EditProductForm />
    </>
  );
} 